import React from 'react';
import { getTranslatedString } from 'helpers/i18n';
import { formatMoney, toFriendlyDateString } from 'helpers/Formatter';
import {
  Card,
  Header,
  Body,
  Col,
  BoldTitle,
  BoldText,
  GreyText,
  HorizontalDivider,
  MobileItem,
} from '../common/Card';
import MediaQuery from 'react-responsive';

const LeasePricingCard = ({ monthlyRent, specialConcession, charges }) => {
  return (
    <React.Fragment>
      <MediaQuery query="(min-device-width: 750px)">
        <Card>
          <Header>
            <BoldTitle>
              {getTranslatedString('landlordPortal.rentRoll.renewals.leasePricing')}
            </BoldTitle>
          </Header>
          <HorizontalDivider />
          <div>
            <Body>
              <GreyText>
                {getTranslatedString('landlordPortal.rentRoll.renewals.monthlyTotal')}
              </GreyText>
              <BoldText>{formatMoney(parseFloat(monthlyRent))}</BoldText>
            </Body>
            <Body>
              <GreyText>
                {getTranslatedString('landlordPortal.rentRoll.renewals.specialConcession')}
              </GreyText>
              <BoldText>{formatMoney(parseFloat(specialConcession))}</BoldText>
            </Body>
          </div>
          <Header>
            <BoldTitle>{getTranslatedString('landlordPortal.rentRoll.renewals.items')}</BoldTitle>
          </Header>
          <HorizontalDivider />
          <Body>
            <Col>
              <GreyText>{getTranslatedString('landlordPortal.rentRoll.renewals.item')}</GreyText>
            </Col>
            <Col>
              <GreyText>
                {getTranslatedString('landlordPortal.rentRoll.renewals.monthlyRent')}
              </GreyText>
            </Col>
            <Col>
              <GreyText>
                {getTranslatedString('landlordPortal.rentRoll.renewals.startDate')}
              </GreyText>
            </Col>
            <Col>
              <GreyText>{getTranslatedString('landlordPortal.rentRoll.renewals.endDate')}</GreyText>
            </Col>
          </Body>
          {charges.map(charge => {
            const { descripton, amount, from_date, to_date } = charge;
            return (
              <Body>
                {/* description of the charges is spelled wrong in Yardis GetLeaseOffers API */}
                <Col>
                  <BoldText>{descripton}</BoldText>
                </Col>
                <Col>
                  <BoldText>{formatMoney(parseFloat(amount))}</BoldText>
                </Col>
                <Col>
                  <BoldText>{toFriendlyDateString(from_date) || '-'}</BoldText>
                </Col>
                <Col>
                  <BoldText>{toFriendlyDateString(to_date) || '-'}</BoldText>
                </Col>
              </Body>
            );
          })}
        </Card>
      </MediaQuery>

      <MediaQuery query="(max-device-width: 750px)">
        <Card>
          <Header>
            <BoldTitle>
              {getTranslatedString('landlordPortal.rentRoll.renewals.leasePricing')}
            </BoldTitle>
          </Header>
          <HorizontalDivider />
          <div>
            <Body>
              <GreyText>
                {getTranslatedString('landlordPortal.rentRoll.renewals.monthlyTotal')}
              </GreyText>
              <BoldText>{formatMoney(parseFloat(monthlyRent))}</BoldText>
            </Body>
            <Body>
              <GreyText>
                {getTranslatedString('landlordPortal.rentRoll.renewals.specialConcession')}
              </GreyText>
              <BoldText>{formatMoney(parseFloat(specialConcession))}</BoldText>
            </Body>
          </div>
          <Header>
            <BoldTitle>{getTranslatedString('landlordPortal.rentRoll.renewals.items')}</BoldTitle>
          </Header>

          {charges.map((charge, index) => {
            const { descripton, amount, from_date, to_date } = charge;
            /* description of the charges is spelled wrong in Yardis GetLeaseOffers API */
            return (
              <React.Fragment>
                <HorizontalDivider />
                <Body margin="0px 0px 16px">
                  <MobileItem>
                    <GreyText>
                      {getTranslatedString('landlordPortal.rentRoll.renewals.itemNumber', {
                        number: index + 1,
                      })}
                    </GreyText>
                    <BoldText>{descripton}</BoldText>
                  </MobileItem>
                </Body>
                <Body margin="0px 0px 16px">
                  <MobileItem>
                    <GreyText>
                      {getTranslatedString('landlordPortal.rentRoll.renewals.monthlyRent')}
                    </GreyText>
                    <BoldText>{formatMoney(parseFloat(amount))}</BoldText>
                  </MobileItem>
                </Body>
                <Body margin="0px 0px 16px">
                  <MobileItem>
                    <GreyText>
                      {getTranslatedString('landlordPortal.rentRoll.renewals.startDate')}
                    </GreyText>
                    <BoldText>{toFriendlyDateString(from_date) || '-'}</BoldText>
                  </MobileItem>
                  <MobileItem textAlign="right">
                    <GreyText>
                      {getTranslatedString('landlordPortal.rentRoll.renewals.endDate')}
                    </GreyText>
                    <BoldText>{toFriendlyDateString(to_date) || '-'}</BoldText>
                  </MobileItem>
                </Body>
              </React.Fragment>
            );
          })}
        </Card>
      </MediaQuery>
    </React.Fragment>
  );
};

export default LeasePricingCard;
